import { render, staticRenderFns } from "./WelcomeMenuCard.vue?vue&type=template&id=4387a273&scoped=true&"
import script from "./WelcomeMenuCard.vue?vue&type=script&lang=js&"
export * from "./WelcomeMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeMenuCard.vue?vue&type=style&index=0&id=4387a273&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387a273",
  null
  
)

export default component.exports